import { create } from "zustand";
import { devtools } from "zustand/middleware";

const STORE_NAME = "FILES_STORE";
const INIT_STATE = {
  files: [],
};

const store = (set) => ({
  ...INIT_STATE,
  setFiles: async (files) => set(() => ({ files })),
});

export const filesStore = create(devtools(store, { name: STORE_NAME }));
